export function statCounterCard(finalValue) {
  finalValue = Number(finalValue) || 0;

  const counterDuration = 1300; // 0.1s -> 1.4s in the design timeline
  const counterDelay = 100; // 0.1s
  const counterFloor = Math.min(1, finalValue);

  // Preserve however many decimal places the source value has (e.g. "4.5" -> 1)
  // so the animation never rounds a decimal stat down to a whole number.
  const decimalPlaces = (String(finalValue).split('.')[1] || '').length;
  const format = (value) => (decimalPlaces > 0 ? value.toFixed(decimalPlaces) : Math.round(value));

  let raf = null;

  return {
    visible: false,
    displayValue: finalValue,

    reveal() {
      if (this.visible) return;
      this.visible = true;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.displayValue = finalValue;
        return;
      }

      this.displayValue = format(counterFloor);
      window.setTimeout(() => this.animateCounter(), counterDelay);
    },

    animateCounter() {
      const start = performance.now();

      const step = (now) => {
        const t = Math.min((now - start) / counterDuration, 1);
        const eased = 1 - Math.pow(1 - t, 3); // ease-out: bigger jumps early, smaller near the end

        this.displayValue = format(counterFloor + (finalValue - counterFloor) * eased);

        if (t < 1) {
          raf = requestAnimationFrame(step);
        }
      };

      raf = requestAnimationFrame(step);
    },

    destroy() {
      if (raf) cancelAnimationFrame(raf);
    }
  };
}
